import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiTrash2, FiCopy, FiLayout } from 'react-icons/fi'
import toast from 'react-hot-toast'
import api from '../utils/api'

export default function Templates() {
  const [templates, setTemplates] = useState([])
  const navigate = useNavigate()

  useEffect(() => { loadTemplates() }, [])

  const loadTemplates = async () => {
    try { const { data } = await api.get('/templates'); setTemplates(data) } catch (e) { /* ignore */ }
  }

  const applyTemplate = async (templateId) => {
    const name = prompt('Yeni dashboard adı:')
    if (!name) return
    try {
      const { data } = await api.post('/templates/apply', {
        template_id: templateId,
        new_dashboard_name: name,
      })
      toast.success('Dashboard şablondan oluşturuldu')
      navigate(`/designer/${data.id}`)
    } catch (err) {
      toast.error('Oluşturulamadı')
    }
  }

  const deleteTemplate = async (id) => {
    if (!confirm('Şablon silinecek. Emin misiniz?')) return
    try { await api.delete(`/templates/${id}`); toast.success('Silindi'); loadTemplates() } catch (e) { toast.error('Silinemedi') }
  }

  const CATEGORY_COLORS = {
    satis: 'bg-green-100 text-green-700',
    lojistik: 'bg-blue-100 text-blue-700',
    finans: 'bg-yellow-100 text-yellow-700',
    genel: 'bg-gray-100 text-gray-600',
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-1">Şablonlar</h1>
      <p className="text-sm text-gray-500 mb-6">Hazır şablonlardan hızlıca dashboard oluşturun</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates.map((t) => (
          <div key={t.id} className="bg-white rounded-xl border border-gray-100 p-5 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center">
                  <FiLayout className="text-purple-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">{t.name}</h3>
                  {t.category && (
                    <span className={`text-xs px-2 py-0.5 rounded ${CATEGORY_COLORS[t.category] || CATEGORY_COLORS.genel}`}>
                      {t.category}
                    </span>
                  )}
                </div>
              </div>
            </div>
            {t.description && <p className="text-sm text-gray-500 mb-3">{t.description}</p>}
            <div className="flex gap-2 pt-3 border-t border-gray-50">
              <button onClick={() => applyTemplate(t.id)} className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700">
                <FiCopy /> Kullan
              </button>
              <button onClick={() => deleteTemplate(t.id)} className="flex items-center gap-1 text-sm text-red-400 hover:text-red-600 ml-auto">
                <FiTrash2 /> Sil
              </button>
            </div>
          </div>
        ))}

        {templates.length === 0 && (
          <div className="col-span-full text-center py-20 text-gray-400">
            Henüz şablon oluşturulmamış. Dashboard düzenleyicisinde "Şablon Kaydet" butonuyla şablon oluşturabilirsiniz.
          </div>
        )}
      </div>
    </div>
  )
}
